export const WORK_SECTION = {
  FRONT_END: 'frontEnd',
  FULL_STACK: 'fullStack',
};

export const TAG = {
  DESIGN: 'Design',
  FRONT_END: 'Front-end',
  BACK_END: 'Back-end',
  CRAFT_CMS: 'Craft CMS',
  CRM_INTEGRATION: 'CRM Integration',
  // REACT: 'React',
  // TYPESCRIPT: 'TypeScript',
  // NEXT_JS: 'Next.js',
  // AI_TOOLING: 'AI tooling',
};

export const TAGS = {
  CRAFT_FULL_STACK: [TAG.DESIGN, TAG.FRONT_END, TAG.BACK_END, TAG.CRAFT_CMS],
  EMBERS: [
    TAG.DESIGN,
    TAG.FRONT_END,
    TAG.BACK_END,
    TAG.CRAFT_CMS,
    TAG.CRM_INTEGRATION,
  ],
  FRONT_END_AND_BACK_END: [TAG.FRONT_END, TAG.BACK_END, TAG.CRAFT_CMS],
};

const WONGDOODY = {
  workingFor: 'Wongdoody',
  workingForLink: 'https://www.wongdoody.com',
};

const NORTHMOST = {
  workingFor: 'Northmost',
  workingForLink: 'https://www.northmost.com.au',
};

// const TEAM = {
//   workingFor: 'Fluent Cargo (as team member)',
// };

// const HONEST_FOX = {
//   workingFor: 'Honest Fox',
//   workingForLink: 'https://www.honestfox.com.au',
// };

// const DISTANCE_THRESHOLD_SHORT = { min: 0, max: 40 };

const data = [
  {
    section: WORK_SECTION.FRONT_END,
    title: 'Fluent Cargo',
    url: 'https://www.fluentcargo.com',
    // tags: [TAG.REACT, TAG.TYPESCRIPT, TAG.NEXT_JS, TAG.AI_TOOLING],
    summary:
      'Senior member of the team responsible for the front-end of a cargo routing and logistics platform. Involved in planning, UX, UI design and building of features, including:',
    details: [
      'An AI assistant interface and tool-call layer connecting existing ports, global disruptions, emissions calculations and other data to conversational workflows (<a href="https://quiet-result-152845.framer.app/" target="_blank" rel="noopener noreferrer">askfluent.ai</a>)',
      'A complex multi-leg emissions calculator with per-segment CO2e breakdowns',
      'Interactive port visualisation and mapping interfaces',
    ],
  },
  {
    section: WORK_SECTION.FRONT_END,
    title: 'Ferguson Plarre Bakehouse',
    url: 'https://www.fergusonplarre.com.au',
    ...NORTHMOST,
  },
  {
    section: WORK_SECTION.FRONT_END,
    title: 'Bell Shakespeare',
    url: 'https://www.bellshakespeare.com.au',
    ...NORTHMOST,
  },
  {
    section: WORK_SECTION.FRONT_END,
    title: 'Bonds',
    url: 'https://www.bonds.com.au',
    ...WONGDOODY,
  },

  {
    section: WORK_SECTION.FRONT_END,
    title: 'RACV',
    url: 'https://www.racv.com.au',
    ...WONGDOODY,
  },
  // {
  //   section: WORK_SECTION.FRONT_END,
  //   title: 'Powershop',
  //   url: 'https://www.powershop.com.au/',
  //   ...HONEST_FOX,
  // },

  // {
  //   section: WORK_SECTION.FRONT_END,
  //   title: 'Sovereign Hill',
  //   url: 'https://sovereignhill.com.au/',
  //   ...WONGDOODY,
  // },

  // {
  //   section: WORK_SECTION.FRONT_END,
  //   title: 'The Australian Ballet',
  //   url: 'https://australianballet.com.au/',
  //   ...WONGDOODY,
  // },

  // {
  //   section: WORK_SECTION.FRONT_END,
  //   title: 'Envato',
  //   url: 'https://envato.com/',
  //   ...WONGDOODY,
  // },

  // {
  //   section: WORK_SECTION.FRONT_END,
  //   title: 'The Walter & Eliza Hall Institute',
  //   url: 'https://discovery.wehi.edu.au/',
  //   ...WONGDOODY,
  // },

  {
    section: WORK_SECTION.FULL_STACK,
    title: 'Embers',
    url: 'https://www.embersyork.co.uk',
    tags: TAGS.EMBERS,
  },

  {
    section: WORK_SECTION.FULL_STACK,
    title: 'Robot Fights Monster',
    url: 'https://www.robotfightsmonster.com/',
    tags: TAGS.FRONT_END_AND_BACK_END,
  },

  {
    section: WORK_SECTION.FULL_STACK,
    title: 'Shambles Kitchen',
    url: 'https://www.shambleskitchen.co.uk',
    tags: TAGS.CRAFT_FULL_STACK,
  },

  // {
  //   section: WORK_SECTION.FRONT_END,
  //   title: 'English Tapware',
  //   url: 'https://www.englishtapware.com.au/',
  // },
];

export default data;
